import SandboxPoster from '@/framework/events/SandboxPoster';
import { sensitiveAddress } from '@/utils';
import { Button } from 'antd';
import { ReactElement, useCallback } from 'react';
import { Link } from 'react-router-dom';

const X402LocalLoad = (props: X402PaymentRequirement): ReactElement => {
    const labelStyle: React.CSSProperties = {
        display: 'inline-block',
        width: 90,
        textAlign: 'right',
        fontWeight: 600,
        color: '#888',
        marginRight: 12,
    };
    const rowStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
    };
    const closeModel = useCallback(() => {
        SandboxPoster.Post('ModelClose', {});
    }, []);
    return (
        <div style={{ padding: 16, fontSize: 16 }}>
            <div
                style={{
                    background: '#00000040',
                    border: '1px solid #00000040',
                    color: '#fffaeabf',
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 18,
                    textAlign: 'left',
                    fontWeight: 500,
                    fontSize: 15,
                    lineHeight: 1.6,
                }}>
                <div>
                    当前请求须支付，<b>本地账户金额不足，无法完成本次交易</b>。<br />
                    请前往页面进行充值操作，充值完成后进行后续操作。
                    <br />
                    <span style={{ fontWeight: 600, color: '#d48806' }}>支付信息如下：</span>
                </div>
            </div>
            <div style={rowStyle}>
                <span style={labelStyle}>支付协议：</span>
                <span>{props.scheme}</span>
            </div>
            <div style={rowStyle}>
                <span style={labelStyle}>网络：</span>
                <span>{props.network}</span>
            </div>
            <div style={rowStyle}>
                <span style={labelStyle}>代币：</span>
                <span>{props.token}</span>
            </div>
            <div style={rowStyle}>
                <span style={labelStyle}>金额：</span>
                <span>{props.amount}</span>
            </div>
            <div style={rowStyle}>
                <span style={labelStyle}>收款地址：</span>
                <span>{sensitiveAddress(props.destination)}</span>
            </div>
            <div style={rowStyle}>
                <span style={labelStyle}>支付场景：</span>
                <span>{props.scene}</span>
            </div>
            <Button type="primary" onClick={closeModel}>
                支付
            </Button>
        </div>
    );
};

export default X402LocalLoad;
